const {
    REACT_APP_PREFIX_IMAGE_LINK
} = process.env;

export const config = {
    prefixes: {
        imagePrefix: REACT_APP_PREFIX_IMAGE_LINK
    }
};